/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React, { useState } from "react";
import { Box, Stack, TextField, Tooltip, Typography, Grid, Button } from "@mui/material";
import { convertHeaderDateTimes, toUTC } from "../../utils/Functions";
import { Effect, Nullable } from "../../utils/Interfaces";
import { modifyField } from "./formControlsFunctions";

import { useAppDispatch } from "../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export interface MobileTimeSelectorProps<ParentModel> {
    field: Nullable<string>;
    updatePath: string;
    updateKey: keyof ParentModel;
    label: string;
    readonly: boolean;
    onUpdate: Effect;
}

const MobileTimeSelector = <ParentModel,>(props: MobileTimeSelectorProps<ParentModel>) => {
    const { field, updatePath, updateKey, label, readonly, onUpdate } = props;

    const darkTheme: boolean = localStorage.getItem("techwiseTheme") === "dark";

    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    const [state, setState] = useState<Nullable<string>>(field);

    return (
        <Box sx={{ marginBottom: 2 }}>
            <Grid xs={12} container>
                <Grid xs={4} item>
                    <Typography>{label}</Typography>
                </Grid>

                <Grid xs={6} item>
                    <TextField
                        id={updateKey as string}
                        type="datetime-local"
                        value={state ? convertHeaderDateTimes(state) : ""}
                        onChange={(event) => {
                            let modDateTime = event.target.value.replace("Z", "") + ":00";
                            setState(modDateTime);
                            modifyField<ParentModel>(
                                updatePath,
                                updateKey,
                                toUTC(new Date(modDateTime)).toISOString(),
                                dispatch,
                                onUpdate
                            );
                        }}
                        sx={{ colorScheme: darkTheme ? "dark" : "light" }}
                        size="small"
                        fullWidth
                        disabled={readonly}
                        inputProps={{ step: 60 }}
                    />
                </Grid>

                <Grid xs={2} item>
                    <Tooltip title="Reset Time Entry">
                        <Stack direction="row" justifyContent="flex-end">
                            <Button
                                onClick={() => {
                                    setState("");
                                    modifyField<ParentModel>(updatePath, updateKey, null, dispatch, onUpdate);
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                    </Tooltip>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MobileTimeSelector;
